import RateInput from './RateInput';
export default RateInput;